/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
import React from 'react'
import styles from '../style/list.css'
import {MessageRowProps} from '../columns/Message'
import {areaDependentComponents} from './areas'

export const ExpandedRowAdditionalComponentContainer = ({
  item
}: {
  item: MessageRowProps['item']
}) => {
  // nosemgrep: eslint.detect-object-injection
  const AdditionalComponent = areaDependentComponents[item.area!]?.ExpandedRowAdditionalComponent

  if (!AdditionalComponent) {
    return null
  }

  return (
    <div className={styles['list__row']}>
      <AdditionalComponent item={item} />
    </div>
  )
}
